const o = {
  id: "ColoradoPick3",
  logo: !0,
  name: "Pick 3",
  style: {
    colorPrimary: "#411b61"
  }
};
export {
  o as default
};
